Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Spotify", {
  enumerable: true,
  get: function get() {
    return _spotify.Spotify;
  }
});
var _spotify = require("./spotify");